import React, { useEffect, useMemo, useState } from "react";
import "./Home.css";
import API_BASE_URL from "../../config";
import SEO from "../../Components/SEO/SEO.jsx";
import Image from "../../Components/Image/Image";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { categoriesService } from "../../Modules/Services/categories.service.ts";
import { promotionsService } from "../../Modules/Services/promotions.service.ts";

const Home = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [promotions, setPromotions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [cats, promos] = await Promise.all([
          categoriesService.getCategories(),
          promotionsService.getActivePromotions(),
        ]);
        setCategories(cats);
        setPromotions(promos);
      } catch (error) {
        console.error("Ошибка при получении данных:", error);
      }
    };

    fetchData();
  }, []);

  const hasPromotions = useMemo(
    () => Array.isArray(promotions) && promotions.length > 0,
    [promotions]
  );

  return (
    <div className="Home--Container">
      <SEO
        title="Меню кафе Шахризада"
        description="Полное меню нашего кафе: шаурма, арабский кофе, восточные сладости"
        keywords="меню, цены, шаурма, кофе, десерты"
      />

      {hasPromotions && (
        <div className="Home--Section">
          <div className="Home--SectionTitle">Акции</div>
          <div
            className={`Home--PromotionsRow ${
              promotions.length === 1 ? "Home--PromotionsRow--single" : ""
            }`}
          >
            {promotions.map((p) => (
              <div key={p.id} className="Home--PromotionCard">
                {p.image_url && (
                  <div className="Home--PromotionImage">
                    <Image
                      src={`${API_BASE_URL}${p.image_url}`}
                      alt="Акция"
                      className="Home--PromotionImgEl"
                    />
                  </div>
                )}
                <div className="Home--PromotionText">{p.description}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="Home--Section">
        <div className="Home--SectionTitle">Категории</div>
        <div className="Home--Categories">
          {categories.map((category) => {
            return (
              <button
                key={category.category_id}
                type="button"
                className="Home--CategoryCard"
                onClick={() => {
                  navigate(`/category/${category.category_id}`);
                }}
              >
                <div className="Home--CategoryCardImage">
                  {category.category_image_url ? (
                    <Image
                      src={`${API_BASE_URL}${category.category_image_url}`}
                      alt={category.category_name}
                      className="Home--CategoryCardImgEl"
                    />
                  ) : (
                    <div className="Home--CategoryCardImgPlaceholder" />
                  )}
                </div>
                <div className="Home--CategoryCardTitle">
                  {category.category_name}
                </div>
                <ChevronRight className="Home--CategoryCardArrow" size={22} />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Home;
